export const FilePathRegex = '^[^>:"|?%#*<\\\\]+$';
export const FlareSpecialChars = '%#';
export const FlareSpecialCharsRegex = `^[^${FlareSpecialChars}]*$`;
export const FlareProjectNameRegex = '^[a-zA-Z0-9_][a-zA-Z0-9\\-_\\. ]*(?<!\\.)$';
